













import Vue from 'vue';
import FooterLink from './FooterLink.vue';

export default Vue.extend({
  name: `Legal`,
  components: { FooterLink },
  data(): unknown {
    return {
      links: window.vueFooter.legal.links,
    };
  },
  methods: {
    unsubscribeNewsletter(): void {
      // taken from footer.php
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $(`#nlUnsubscribe`).foundation(`open`);
    },
  },
});
